module.exports = __webpack_public_path__ + "static/media/download.07ea1423.svg";